import { accessTokenAtom, refreshTokenAtom } from "@/atoms/authAtoms";
import userAtom, { User } from "@/atoms/userAtom";
import { authStore } from "@/stores/auth.store";
import { MethodologyWithRoundDetails, Reviewer } from "@/types/Methodology";
import { AccessLevelHierarchy, UserRole } from "@/types/Role";

export function isOriginator(user: User, originatorId: number) {
	return originatorId === user.id;
}

export function isReviewerOfGivenMethodology(user: User, methodologywithRoundDetails: MethodologyWithRoundDetails) {
	return (
		userHasMinimumAccessLevel(UserRole.EXPERT_REVIEWER, user.rolesInfo) &&
		Boolean(methodologywithRoundDetails?.reviewers?.find((reviewer) => reviewer.reviewerUserId == user.id.toString()))
	);
}

export function userHasMinimumAccessLevel(targetRole: UserRole, relationships: AccessLevelHierarchy[]) {
	if (!relationships) {
		authStore.set(userAtom, null);
		authStore.set(accessTokenAtom, undefined);
		authStore.set(refreshTokenAtom, undefined);
		return;
	}
	return (
		relationships[0]?.role === targetRole ||
		relationships[0]?.supercedes.includes(targetRole) ||
		relationships[0]?.siblings.includes(targetRole)
	);
}

export function isUserActiveReviewer(params: { user?: User | null; reviewers: Reviewer[] }): boolean {
	const { user, reviewers } = params;
	const reviewerFoundInActiveList = reviewers?.find((reviewer) => reviewer.reviewerUserId == user?.id.toString());
	return Boolean(reviewerFoundInActiveList);
}
